import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '@/lib/api';
import { PublicLayout } from '@/components/public/PublicLayout';
import { Seo } from '@/components/Seo';
import { ContactsView } from '@/components/public/ContactsView';

export default function Contatti() {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'it';
  const [info, setInfo] = useState({});

  useEffect(() => {
    api.get('/cms/contacts').then(({ data }) => setInfo(data?.data || {})).catch(() => {});
  }, []);

  const title = lang === 'en' ? "Let's talk" : 'Parliamone';
  const description = lang === 'en'
    ? 'Got a question or a proposal? Our team will get back to you soon.'
    : 'Hai una domanda o una proposta? Il nostro team ti risponde al piu\u0301 presto.';

  return (
    <PublicLayout>
      <Seo title={title} description={description} path="/contatti" />
      <ContactsView info={info} lang={lang} />
    </PublicLayout>
  );
}
